// extracted by mini-css-extract-plugin
export var profileSlidingTabsContainer = "styles-module__profileSlidingTabsContainer___KkU1T";
export var tabBar = "styles-module__tabBar___eDRlc";